import styled from 'styled-components';
import { Card } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { colors } from '@theme/colors';
import { HSMSIcon } from './HSMSIcon';

export const HSMSCard = styled(Card)`
  border-radius: 4px;
`;

export const HSMSSessionLink = styled.a`
  float: right;
  margin-bottom: 10px;
`;

export const HSMSSessionCard = styled(HSMSCard)`
  width: 407px;

  .ant-card-body {
    margin-bottom: -14px;
  }

  .ant-card-meta-avatar {
    float: right;
    padding-top: 12px;
    padding-right: 0;
  }
`;

export const HSMSSessionCardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const HSMSCardIcon = styled.div`
  width: 41px;
  height: 41px;
  border-radius: 50%;
  background: ${colors.secondaryBGColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border-style: solid;
  border-color: ${colors.primaryColor};
  border-width: thin;

  i {
    color: ${colors.primaryColor};
  }
`;

export const HSMSSiderIcon = styled(HSMSIcon)`
  vertical-align: -2px;
  margin-right: 7px;
`;

export const HSMSPageHeaderWrapper = styled.div`
  background-color: ${colors.primaryBGColor};
  box-shadow: 3px 0 5px rgba(0, 0, 0, 0.09);
`;

export const HSMSContentCard = styled(HSMSCard)`
  margin: 24px;
  box-shadow: 3px 0 5px rgba(0, 0, 0, 0.09);
`;

export const HSMSStepTabContentCard = styled.div`
  margin: 24px;

  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-content {
    background-color: #ffffff;
    box-shadow: 3px 0 5px rgba(0, 0, 0, 0.09);
    padding: 24px;
    border: 1px solid #f0f0f0;
    border-radius: 0 4px 4px 4px;
  }

  .ant-tabs-tab {
    box-shadow: 3px 0 5px rgba(0, 0, 0, 0.09);
    border: 1px solid #f0f0f0;
    border-radius: 4px 4px 0 0;
  }
`;

export const HSMSStepContentCard = styled(HSMSContentCard)`
  .ant-card-body {
    padding: 0;
  }

  .hsms-card-body {
    padding: 24px;
  }

  .hsms-card-body-small {
    padding: 24px 17px 24px 5px;
    display: flex;
    align-items: center;
  }

  .hsms-card-body-items-center {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3rem;
  }

  .step-actions-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .step-actions-wrapper-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .step-actions {
    text-align: right;

    .step-action-button-margin {
      margin-left: 8px;
    }
  }
`;

export const HSMSFilterIcon = styled(FilterOutlined)`
  color: ${colors.iconDefaultColor};
`;

interface HSMSSessionContainerProps {
  sessionBg: string;
}

export const HSMSSessionContainer = styled.div<HSMSSessionContainerProps>`
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  background-image: url('/images/session-bg.jpg');
`;

export const FormHelperContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .switch-container {
    display: flex;
    flex-direction: row;
  }
`;

export const DrawerFooter = styled.div`
  margin-bottom: 24px;
  text-align: right;
`;

export const BreadcrumbWrapper = styled.div`
  margin: 24px;
`;

export const ImageStepWrapper = styled.div`
  text-align: center;

  .bot {
    width: 200px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 36px;
    margin-bottom: 22px;
  }
`;
